<template>
    <div class="form-container bg-white">
        <div class="form-container-header">
            <div class="form-title">
                <div
                    class="form-title-title"
                    v-html="$t('authorization.login.card_title')"></div>
            </div>
        </div>
        <form @submit.prevent='checkLoginForm()'>
            <div class="form-container-body">
                <div class="form-row">
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <input
                                type="email"
                                name="user_email"
                                v-model='loginForm.email'
                                v-validate='"required|email"'
                                :class="{'is-danger': errors.has('user_email') }"
                                class="form-control"
                                :placeholder="$t('authorization.login.placeholder.email')"
                            >
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <input
                                type="password"
                                name="user_password"
                                v-model='loginForm.password'
                                v-validate='"required"'
                                :class="{'is-danger': errors.has('user_password') }"
                                class="form-control"
                                :placeholder="$t('authorization.login.placeholder.password')"
                            >
                        </div>
                    </div>
                    <transition name="fade" v-if="$store.state.loading">
                        <b-col md="12" class="d-flex justify-content-center mb-2">
                            <b-spinner class="align-middle text-info"></b-spinner>
                        </b-col>
                    </transition>
                </div>
                <div class="form-row">
                    <div class="col">
                        <div
                            class="is-danger-color mt-2 mb-2"
                            v-if="loginFormErrors.show">
                            <!--{{ loginFormErrors.status }} - {{ loginFormErrors.title }}-->
                            <div
                                v-if="loginFormErrors.errors.length"
                                v-for="error in loginFormErrors.errors"
                                :key="error"
                            >
                                {{$t(error.message)}}
                            </div>
                            <div v-text="$t(loginFormErrors.detail)"></div>
                        </div>
                        <div class="form-group">
                            <b-btn type="submit"
                                :disabled="$store.state.loading"
                                variant="primary-user"
                                class="form-container-btn"
                                v-html="$t('authorization.login.btn_login')"></b-btn>
                        </div>
                    </div>
                </div>
                <div class="form-row align-items-center">
                    <div class="col-md-6">
                        <div class="form-check">
                            <div class="checkbox">
                                <input
                                    type='checkbox'
                                    name='user_remember'
                                    v-model='loginForm.remember'
                                >
                                <label v-html="$t('authorization.login.stay_in')"></label>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 text-right">
                    </div>
                </div>
            </div>
            <div class="form-container-footer">
                <router-link
                    class="form-container-link"
                    :to="{ name: 'register' }"
                    v-html="$t('authorization.login.create_account')"></router-link>
            </div>
        </form>
    </div>
</template>

<script>
    import SocialButton from '../Social/SocialButton/SocialButton.vue'
    import axios from 'axios'

    export default {
        name: 'login',
        components: {
            SocialButton
        },
        data() {
            return {
                loginForm: {
                    email: '',
                    password: '',
                    remember: false
                },

                loginFormErrors: {
                    show: false,
                    status: 0,
                    title: '',
                    errors: [],
                    detail: ''
                }
            }
        },
        methods: {
            checkLoginForm() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.submitLoginForm()
                    }
                })
            },

            setErrors(data, show) {
                this.loginFormErrors.status = data ? data.status : ''
                this.loginFormErrors.title = data ? data.title : ''
                this.loginFormErrors.errors = data ? data.errors : []
                this.loginFormErrors.detail = data ? data.detail : ''
                this.loginFormErrors.show = show
            },

            submitLoginForm() {
                let body = {
                    email: this.loginForm.email,
                    password: this.loginForm.password
                }

                axios({
                    method: 'POST',
                    url: this.$endpoints.login,
                    data: body,
                    headers: {'Authorization': null}
                }).then((response) => {
                    if (response.data.token) {
                        let loginData = {
                            save: this.loginForm.remember,
                            role: 'user',
                            tokens: {
                                token: response.data.token,
                                refreshToken: response.data.refreshToken
                            },
                            roles: response.data.user.roles
                        }
                        this.setErrors({}, false)
                        this.$store.commit('TOKENS', loginData)
                        if (this.loginForm.remember === false) {
                            this.$store.commit('LOGOUT_TIMER')
                        }
                        this.$route.query.redirect ? this.$router.push(this.$route.query.redirect) : this.$router.push({name: 'UserPanel'})
                    }
                }).catch((error) => {
                    this.setErrors(error.response.data, true)
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Authentication/Login/Login.vue